import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import Layout from "../components/Layout";
import { Lock, ArrowLeft } from "lucide-react";

export default function TilbakestillPassord() {
  const { token } = useParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) { setError("Passordet må være minst 8 tegn"); return; }
    if (pw !== pw2) { setError("Passordene er ikke like"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      try { await refresh(); } catch (_) { /* refresh feil skal ikke blokkere navigering */ }
      nav("/", { replace: true });
    } catch (e2) {
      setError(e2.response?.data?.detail || "Kunne ikke tilbakestille passord");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto pt-12" data-testid="reset-password-page">
        <Link to="/?tab=login" className="font-meta text-[10px] tracking-[0.2em] text-[var(--cream-soft)] hover:text-[var(--magenta)] flex items-center gap-1 mb-6">
          <ArrowLeft className="h-3 w-3" /> TILBAKE
        </Link>

        <div className="font-meta text-[10px] tracking-[0.3em] text-[var(--magenta)] mb-2 flex items-center gap-2">
          <Lock className="h-3 w-3" /> NYTT PASSORD
        </div>
        <h1 className="font-fraunces italic text-4xl text-[var(--cream)] mb-8">Velg nytt passord</h1>

        <form onSubmit={submit} className="space-y-4">
          <input
            type="password"
            required
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            placeholder="Nytt passord (min. 8 tegn)"
            className="input-editorial w-full"
            data-testid="reset-pw-input"
          />
          <input
            type="password"
            required
            value={pw2}
            onChange={(e) => setPw2(e.target.value)}
            placeholder="Bekreft passord"
            className="input-editorial w-full"
            data-testid="reset-pw2-input"
          />
          {error && <div className="text-sm text-[var(--magenta)]" data-testid="reset-error">{error}</div>}
          <button type="submit" disabled={busy} className="btn-magenta w-full" data-testid="reset-submit">
            {busy ? "Lagrer…" : "Bytt passord & logg inn"}
          </button>
        </form>
      </div>
    </Layout>
  );
}
